import { FormikSelectInputNative } from '@palmetto/palmetto-components';
import { Field, useFormikContext } from 'formik';
import { useEffect, useMemo } from 'react';

import { ProgramType } from 'types';

import { useGetUtilitiesQuery } from '../../services/utilities';

export const UtilityNameSelectInput = ({
  isDisabled,
  programType,
}: {
  isDisabled: boolean;
  programType?: ProgramType;
}) => {
  const filter = [{ id: 'programType', operation: 'Equal', selectedValues: [programType] }];
  const { data: utilities = [], isLoading: isUtilitiesLoading } = useGetUtilitiesQuery(
    programType ? { advancedFilters: JSON.stringify(filter) } : {},
  );
  const { values, isSubmitting, setFieldValue } = useFormikContext<{ lseId: string | number; state: string }>();

  const utilityOptions = useMemo(() => {
    if (!values.state || values.state === '' || isUtilitiesLoading) {
      return [];
    }
    const utilitiesByState = utilities.filter(
      (utility: any) =>
        utility.state === values.state && (utility.status === 'active' || utility.lseId === values.lseId),
    );
    return utilitiesByState.map((utility: any) => ({
      value: utility.lseId,
      label: utility.name,
    }));
  }, [values.state, isUtilitiesLoading, utilities]);

  useEffect(() => {
    if (isUtilitiesLoading || !utilityOptions.length) {
      return;
    }

    const isValidSelection = utilityOptions.some((option) => option.value === values.lseId);

    if (values.lseId && !isValidSelection) {
      setFieldValue('lseId', '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [utilityOptions, isUtilitiesLoading]);

  return (
    <Field
      type="text"
      label="Utility Name"
      name="lseId"
      id="lseId"
      options={utilityOptions}
      component={FormikSelectInputNative}
      isRequired
      autoComplete="off"
      isDisabled={isSubmitting || isUtilitiesLoading || isDisabled}
      style={{ marginRight: 'var(--size-spacing-xl)' }}
    />
  );
};
